<template>
  <b-modal
    id="invoices-payments"
    size="lg"
    ref="modalInvoicesPayments"
    :ok-only="true"
    @ok="handleSubmit()"
    @cancel="handleClose()"
    @close="handleClose()"
    v-model="modalOpen"
    :modal-class="{'no-close-icon': loading}"
  >
    <div v-if="loading" class="text-center text-success my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Загрузка</strong>
    </div>

    <template #modal-footer="{ cancel, ok, close }">
      <b-button v-if="!loading" size="sm" variant="secondary" @click="cancel()">
        Закрыть
      </b-button>
      <b-button v-if="!loading" size="sm" variant="success" @click="ok()">
        <font-awesome-icon icon="save" class="mr-1" />
        Сохранить
      </b-button>
    </template>

    <div v-if="!loading">
      <b-card no-body v-if="newItem != null">
        <b-card-header>
          <b-row align-v="center">
            <b-col cols="auto" class="mr-auto">
              <h5 class="mb-0">Оплаты счёта № {{this.newItem.numb}}</h5>
            </b-col>
            <b-col cols="auto" class="mr-auto">
              <span class="text-small">Статус</span>
              <b-badge pill :variant="getStatusStyle(newItem.paid_type)">
                {{getStatusName(newItem.paid_type)}}
              </b-badge>
            </b-col>
            <b-col cols="auto">
              <b-button size="sm" variant="success" @click.stop="onAddPayment()">
                <font-awesome-icon icon="plus" class="mr-1"/>
                Добавить
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>

        <b-table
          id="invoice-payments"
          ref="invoice-payments"
          class="mb-0"
          selectable
          select-mode="single"
          selectedVariant="success"
          striped
          small
          thead-class="top-fixed-thead thead-light"
          table-class="text-small"
          responsive
          show-empty
          :empty-text="$t('message.common.emptyTable')"
          :items="newItem.payments"
          :fields="paymentsFields"
          :per-page="paymentsPerPage"
          :current-page="paymentsCurrentPage"
          :sort-by.sync="paymentsSortBy"
          :sort-desc.sync="paymentsSortDesc"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >

          <template #cell(numb)="row">
            <b-form-input
              id="input_number"
              size="sm"
              autocomplete="off"
              v-model.number="row.item.numb">
            </b-form-input>
          </template>

          <template #cell(date)="row">
            <b-form-input
              id="input_date"
              size="sm"
              type="date"
              v-model.date="row.item.date"/>
          </template>

          <template #cell(sum)="row">
            <b-form-input
              id="input_contract"
              size="sm"
              class="widthPrice"
              autocomplete="off"
              v-model.number="row.item.sum">
            </b-form-input>
          </template>

          <template #cell(comment)="row">
            <b-form-input
              id="input_town"
              size="sm"
              autocomplete="off"
              v-model="row.item.comment">
            </b-form-input>
          </template>

          <template #cell(action)="row">
            <b-button size="sm" variant="danger" @click="removePayment(row)">
              <font-awesome-icon icon="trash" />
            </b-button>
          </template>
        </b-table>

        <b-card-footer footer-bg-variant="light">
          <b-row align-h="between" align-v="center">
            <b-col cols="auto" class="mr-auto">
              Всего оплат: <b>{{this.newItem.payments.length}}</b> |
              Сумма по оплатам: <b>{{priceFormat(this.totalPaymentsSum)}}</b>
            </b-col>
            <b-col cols="auto">
              <b-pagination
                id="invoices-payments-pagination"
                pills
                :total-rows="this.newItem.payments.length"
                :per-page="paymentsPerPage"
                v-model="paymentsCurrentPage"/>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import invoices from "../../network/invoices";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";

export default {
  name: "InvoicesPayments",
  mixins: [
    invoices,
    helpers, dateFormatter
  ],
  data() {
    return {
      newItem: {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        summa: 0,
        active: true,
        paid_type: 0,
        works: [],
        payments: [],
      },
      isBusy: true,
      paymentsFields: [
        {
          key: 'numb',
          label: '№ Оплаты',
          class: 'widthPrice',
          sortable: false,
        },
        {
          key: 'date',
          label: 'Дата',
          class: 'widthCatalog',
          sortable: true,
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'widthPrice',
          sortable: false,
        },
        {
          key: 'comment',
          label: 'Комментарий',
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom',
          sortable: false,
        },
      ],
      paidTypes: [
        { id: 0, name: "Не оплачено" },
        { id: 1, name: "Оплачено" },
        { id: 2, name: "Частично оплачено" },
        { id: 3, name: "Переплата"}
      ],
      paymentsPerPage: 10,
      paymentsCurrentPage: 1,
      paymentsSortBy: 'date',
      paymentsSortDesc: true,
      modalOpen: false,
      loading: false
    }
  },
  computed: {
    totalPaymentsSum() {
      return this.newItem.payments
        .map(obj => obj.sum)
        .reduce((acc, current) => acc + current, 0)
    },
  },
  methods: {
    async getInvoice(invoiceId) {
      const result = await this.getInvoiceById(invoiceId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.newItem = result.data;
      let payments = this.newItem.payments;
      payments.forEach(function (pay) {
        pay.date = this.formatDate(new Date(pay.date));
      }.bind(this));
      this.newItem.payments = payments;
    },
    async handleSubmit() {
      const date = this.formatServerDate(new Date(this.newItem.date));

      let payments = this.newItem.payments;
      payments.forEach(function (pay) {
        pay.date = this.formatServerDate(new Date(pay.date));
      }.bind(this));

      const taskIds = this.newItem.tasks.map(obj => obj.id);
      const data = {
        id: this.newItem.id,
        date: date,
        summa: this.newItem.summa,
        customer_id: this.newItem.customer_id,
        organization_id: this.newItem.organization_id,
        active: this.newItem.active,
        task_ids: taskIds,
        paid_type: this.newItem.paid_type,
        works: this.newItem.works,
        numb: this.newItem.numb,
        acts: this.newItem.acts,
        payments: payments,
        contract: this.newItem.contract
      }

      const result = await this.putInvoice(data);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.newItem.id = result.data.id;
      this.hideModal();
    },
    onAddPayment() {
      const pay = {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        sum: this.newItem.summa,
        comment: '',
      };
      this.newItem.payments.unshift(pay);
      this.paymentsCurrentPage = 1;
    },
    removePayment(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = 'Удаление оплаты';
      const message = `Вы уверены, что хотите удалить оплату № ${this.deleteRow.numb}?`;
      this.showModalDelete(title, message, function () {
        const index = this.newItem.payments.findIndex(item => item === row.item);
        this.newItem.payments.splice(index,1);
      }.bind(this));
    },
    // Status
    updateStatus() {
      if (this.totalPaymentsSum == 0) {
        this.newItem.paid_type = 0;
        return;
      }

      if (this.totalPaymentsSum < this.newItem.summa) {
        this.newItem.paid_type = 2;
        return;
      }

      if (this.totalPaymentsSum === this.newItem.summa) {
        this.newItem.paid_type = 1;
        return;
      }

      if (this.totalPaymentsSum > this.newItem.summa) {
        this.newItem.paid_type = 3;
        return;
      }
    },
    getStatusName(status_id) {
      const status = this.paidTypes.find(e => e.id === status_id)
      return status != null ? status.name : 'Ошибка';
    },
    getStatusStyle(status_id) {
      switch (status_id) {
        case 0:
          return 'primary';
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'warning';
        default:
          return '';
      }
    },
    // Modal
    async showPayments(invoice) {
      this.modalOpen = true;
      this.loading = true;
      await this.getInvoice(invoice.id).finally(() => {
        this.loading = false;
      });
    },
    hideModal() {
      this.modalOpen = false;
      this.newItem = null;
      this.$emit ("update", null)
    },
    handleClose() {
      this.newItem = null;
    },
  },
  watch: {
    'newItem.payments': {
      handler: function (newValues, _) {
        if (this.newItem) {
          this.updateStatus();
        }
      },
    deep: true
    }
  }
}
</script>

<style>

.no-close-icon .close {
  display: none;
}

#invoices-payments-pagination {
  margin-bottom: 0;
}

#invoice-payments td {
  text-align: center;
}

#invoice-payments th {
  text-align: center;
  vertical-align: middle;
}

#invoices-payments .modal-body {
  padding: 0;
}

.widthPrice {
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoicesPayments.vue